import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { App } from '@gin-betting/core';
import cn from 'classnames';
import { map } from 'lodash';

import { Icon, Toggler } from 'components';
import { useToggler } from 'hooks';
import globalMsg from 'messages';
import CollapsibleSettingsRow from '../CollapsibleSettingsRow';
import useOddsStatisticSelect from './useOddsStatisticSelect';

import chevron from 'assets/svg/chevron.svg';
import './oddsStatisticSelectMobile.scss';

const statisticViewMapping: { [K: string]: MessageDescriptor } = {
    [App.OddStatisticView.MATCH]: globalMsg.byMatch,
    [App.OddStatisticView.MARKET]: globalMsg.byMarket,
};

const OddsStatisticSelect: React.FC = () => {
    const {
        show,
        statisticView,
        handlerStatisticToggle,
        makeOnClick,
    } = useOddsStatisticSelect();

    const [isOpened, openModal] = useToggler(false);

    return (
        <div styleName="container">
            <CollapsibleSettingsRow
                isOpen={isOpened}
                message={show ? globalMsg.on : globalMsg.off}
                onToggle={openModal}
                title={<FormattedMessage {...globalMsg.oddsStatistic} />}
            >
                <React.Fragment>
                    <div styleName="toggler" onClick={handlerStatisticToggle}>
                        <div styleName="toggler-text">
                            <FormattedMessage {...globalMsg.show} />
                        </div>
                        <Toggler
                            onToggle={handlerStatisticToggle}
                            isOpened={show}
                            isDisabled={false}
                        />
                    </div>

                    {map(
                        statisticViewMapping,
                        (title, selected: App.OddStatisticView) => {
                            const isSelected = statisticView === selected;

                            return (
                                <div
                                    key={selected}
                                    styleName={cn('list', {
                                        'is-selected': isSelected,
                                    })}
                                    onClick={makeOnClick(selected)}
                                >
                                    <div styleName="option-title">
                                        {isSelected && (
                                            <Icon
                                                styleName="icon"
                                                glyph={chevron}
                                            />
                                        )}
                                        <FormattedMessage {...title} />
                                    </div>
                                </div>
                            );
                        }
                    )}
                </React.Fragment>
            </CollapsibleSettingsRow>
        </div>
    );
};

export default OddsStatisticSelect;
